import "prismjs/themes/prism.css"
import "typeface-gfs-didot"
import "typeface-aleo"
import "typeface-roboto"
import "slick-carousel/slick/slick.css"
import "slick-carousel/slick/slick-theme.css"
require("./src/css/style.css")
